import React, { useState } from 'react';

const API = 'https://qbdp-backend-production.up.railway.app/api';

export default function ImportCSV({ type, onClose, onSuccess }) {
  const [step, setStep]         = useState('upload'); // upload | preview | result
  const [csvText, setCsvText]   = useState('');
  const [preview, setPreview]   = useState(null);
  const [result, setResult]     = useState(null);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const token = sessionStorage.getItem('qbdp_token');

  const label    = type === 'employes' ? 'employés' : 'clients / patients';
  const labelCap = type === 'employes' ? 'Employés' : 'Clients / Patients';

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.name.endsWith('.csv') && !file.name.endsWith('.txt')) {
      setError('Fichier CSV uniquement (.csv)');
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => setCsvText(ev.target.result);
    reader.readAsText(file, 'UTF-8');
    setError('');
  };

  const handlePreview = async () => {
    if (!csvText) { setError('Sélectionnez un fichier d\'abord'); return; }
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/import/${type}/preview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ csv_text: csvText })
      });
      const d = await r.json();
      if (!r.ok) { setError(d.error || 'Erreur'); setLoading(false); return; }
      setPreview(d);
      setStep('preview');
    } catch { setError('Erreur réseau'); }
    setLoading(false);
  };

  const handleImport = async () => {
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/import/${type}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ csv_text: csvText })
      });
      const d = await r.json();
      if (!r.ok) { setError(d.error || 'Erreur'); setLoading(false); return; }
      setResult(d);
      setStep('result');
      onSuccess();
    } catch { setError('Erreur réseau'); }
    setLoading(false);
  };

  const downloadTemplate = () => {
    window.open(`${API}/import/template/${type}`, '_blank');
  };

  const inp = { width: '100%', border: '1px solid #e5e7eb', borderRadius: 8, padding: '9px 12px', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: 'white', borderRadius: 16, padding: 32, width: 560, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e' }}>📥 Importer des {label}</div>
            <div style={{ fontSize: 13, color: '#6b7280', marginTop: 3 }}>Import depuis un fichier CSV</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#6b7280' }}>✕</button>
        </div>

        {/* Étapes */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
          {['upload', 'preview', 'result'].map((s, i) => (
            <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ width: 24, height: 24, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700,
                background: step === s ? '#1a56db' : ['upload','preview','result'].indexOf(step) > i ? '#16a34a' : '#f3f4f6',
                color: step === s || ['upload','preview','result'].indexOf(step) > i ? 'white' : '#9ca3af' }}>
                {['upload','preview','result'].indexOf(step) > i ? '✓' : i + 1}
              </div>
              <span style={{ fontSize: 12, color: step === s ? '#1a56db' : '#9ca3af', fontWeight: step === s ? 600 : 400 }}>
                {s === 'upload' ? 'Fichier' : s === 'preview' ? 'Aperçu' : 'Résultat'}
              </span>
              {i < 2 && <div style={{ width: 20, height: 1, background: '#e5e7eb' }} />}
            </div>
          ))}
        </div>

        {/* ── ÉTAPE 1 : UPLOAD ── */}
        {step === 'upload' && (
          <div>
            {/* Template download */}
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '12px 16px', marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#15803d' }}>📄 Template CSV</div>
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>Téléchargez le modèle et remplissez-le</div>
              </div>
              <button onClick={downloadTemplate}
                style={{ background: '#16a34a', color: 'white', border: 'none', borderRadius: 8, padding: '7px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                ⬇ Télécharger
              </button>
            </div>

            {/* Colonnes attendues */}
            <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: '12px 16px', marginBottom: 20 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Colonnes acceptées :</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {type === 'employes'
                  ? ['nom', 'matricule', 'service', 'email', 'telephone', 'adresse', 'code_postal', 'ville'].map(c => (
                      <span key={c} style={{ background: '#eff6ff', color: '#1a56db', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6 }}>{c}</span>
                    ))
                  : ['nom', 'type', 'email', 'telephone', 'numero_chambre', 'date_arrivee', 'date_depart', 'statut', 'notes'].map(c => (
                      <span key={c} style={{ background: '#eff6ff', color: '#1a56db', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6 }}>{c}</span>
                    ))
                }
              </div>
              <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 8 }}>
                Séparateur : virgule (,) ou point-virgule (;) — Les noms de colonnes peuvent varier
              </div>
            </div>

            {/* Upload zone */}
            <div
              onClick={() => document.getElementById('csv-input').click()}
              onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = '#1a56db'; }}
              onDragLeave={e => { e.currentTarget.style.borderColor = '#e5e7eb'; }}
              onDrop={e => {
                e.preventDefault();
                e.currentTarget.style.borderColor = '#e5e7eb';
                const file = e.dataTransfer.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = ev => setCsvText(ev.target.result);
                  reader.readAsText(file, 'UTF-8');
                }
              }}
              style={{ border: `2px dashed ${csvText ? '#16a34a' : '#e5e7eb'}`, borderRadius: 12, padding: '32px', textAlign: 'center', cursor: 'pointer', marginBottom: 16, background: csvText ? '#f0fdf4' : '#fafafa' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>{csvText ? '✅' : '📁'}</div>
              <div style={{ fontSize: 14, fontWeight: 500, color: '#374151' }}>
                {csvText ? 'Fichier chargé — cliquer pour en choisir un autre' : 'Cliquer ou glisser un fichier CSV'}
              </div>
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 4 }}>Format .csv — encodage UTF-8 recommandé</div>
            </div>
            <input id="csv-input" type="file" accept=".csv,.txt" style={{ display: 'none' }} onChange={handleFile} />

            {error && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#dc2626', marginBottom: 16 }}>{error}</div>}

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={onClose} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #e5e7eb', background: 'white', fontSize: 13, cursor: 'pointer' }}>Annuler</button>
              <button onClick={handlePreview} disabled={!csvText || loading}
                style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: csvText ? '#1a56db' : '#e5e7eb', color: csvText ? 'white' : '#9ca3af', fontSize: 13, fontWeight: 600, cursor: csvText ? 'pointer' : 'default' }}>
                {loading ? '⏳...' : 'Aperçu →'}
              </button>
            </div>
          </div>
        )}

        {/* ── ÉTAPE 2 : APERÇU ── */}
        {step === 'preview' && preview && (
          <div>
            <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, padding: '12px 16px', marginBottom: 20, display: 'flex', gap: 16 }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 24, fontWeight: 800, color: '#1a56db' }}>{preview.total}</div>
                <div style={{ fontSize: 11, color: '#6b7280' }}>à importer</div>
              </div>
              <div style={{ fontSize: 13, color: '#1e40af' }}>
                <strong>{preview.total} {label}</strong> détectés dans le fichier.<br />
                Aperçu des 5 premiers ci-dessous. Les doublons (même email) seront mis à jour.
              </div>
            </div>

            <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden', marginBottom: 20 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                    {type === 'employes'
                      ? ['Nom', 'Service', 'Email', 'Téléphone'].map(h => <th key={h} style={{ padding: '8px 12px', textAlign: 'left', fontSize: 11, color: '#6b7280', fontWeight: 600 }}>{h}</th>)
                      : ['Nom', 'Type', 'Email', 'N° Référence'].map(h => <th key={h} style={{ padding: '8px 12px', textAlign: 'left', fontSize: 11, color: '#6b7280', fontWeight: 600 }}>{h}</th>)
                    }
                  </tr>
                </thead>
                <tbody>
                  {preview.preview.map((row, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      {type === 'employes' ? (
                        <>
                          <td style={{ padding: '8px 12px', fontSize: 13, fontWeight: 500 }}>{row.nom}</td>
                          <td style={{ padding: '8px 12px', fontSize: 12, color: '#6b7280' }}>{row.service || '—'}</td>
                          <td style={{ padding: '8px 12px', fontSize: 12, color: '#6b7280' }}>{row.email || '—'}</td>
                          <td style={{ padding: '8px 12px', fontSize: 12, color: '#6b7280' }}>{row.telephone || '—'}</td>
                        </>
                      ) : (
                        <>
                          <td style={{ padding: '8px 12px', fontSize: 13, fontWeight: 500 }}>{row.nom}</td>
                          <td style={{ padding: '8px 12px', fontSize: 12, color: '#6b7280' }}>{row.type || '—'}</td>
                          <td style={{ padding: '8px 12px', fontSize: 12, color: '#6b7280' }}>{row.email || '—'}</td>
                          <td style={{ padding: '8px 12px', fontSize: 12, color: '#6b7280' }}>{row.numero_chambre || '—'}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {error && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#dc2626', marginBottom: 16 }}>{error}</div>}

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setStep('upload')} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #e5e7eb', background: 'white', fontSize: 13, cursor: 'pointer' }}>← Retour</button>
              <button onClick={handleImport} disabled={loading}
                style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#1a56db', color: 'white', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                {loading ? '⏳ Import en cours...' : `🚀 Importer ${preview.total} ${label}`}
              </button>
            </div>
          </div>
        )}

        {/* ── ÉTAPE 3 : RÉSULTAT ── */}
        {step === 'result' && result && (
          <div>
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>🎉</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e' }}>Import terminé !</div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
              <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '14px', textAlign: 'center' }}>
                <div style={{ fontSize: 28, fontWeight: 800, color: '#16a34a' }}>{result.imported}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Importés</div>
              </div>
              <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, padding: '14px', textAlign: 'center' }}>
                <div style={{ fontSize: 28, fontWeight: 800, color: '#1a56db' }}>{result.updated}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Mis à jour</div>
              </div>
              <div style={{ background: result.errors > 0 ? '#fef2f2' : '#f9fafb', border: `1px solid ${result.errors > 0 ? '#fecaca' : '#e5e7eb'}`, borderRadius: 10, padding: '14px', textAlign: 'center' }}>
                <div style={{ fontSize: 28, fontWeight: 800, color: result.errors > 0 ? '#dc2626' : '#9ca3af' }}>{result.errors}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Erreurs</div>
              </div>
            </div>

            {result.details && result.details.filter(d => d.action === 'erreur').length > 0 && (
              <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#dc2626', marginBottom: 8 }}>Erreurs détaillées :</div>
                {result.details.filter(d => d.action === 'erreur').map((d, i) => (
                  <div key={i} style={{ fontSize: 12, color: '#dc2626' }}>• {d.nom} : {d.message}</div>
                ))}
              </div>
            )}

            <button onClick={onClose}
              style={{ width: '100%', padding: '11px', borderRadius: 10, border: 'none', background: '#1a56db', color: 'white', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
              ✅ Fermer
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
